<template>
	<div>
		<v-select
			v-model="currentCompany"
			:items="companieList"
			label="Switch or Add Company"
			return-object
			item-text="name"
			item-value="id"
			dense
			solo
			:hide-details="!hint"
			:hint="hint"
			:persistent-hint="!!hint"
			flat
			class="mr-4 font-weight-bold"
			prepend-icon="mdi-domain"
		>
			<template #prepend-item>
				<v-list-item ripple block @mousedown.prevent @click="addPracticeShow = true">
					<v-list-item-action>
						<v-icon>mdi-plus</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item>{{ getLabel('addCompany', 'Add Practice') }}</v-list-item>
					</v-list-item-content>
				</v-list-item>
				<v-divider class="mt-2"></v-divider>
			</template>
		</v-select>

		<v-dialog v-model="addPracticeShow" persistent scrollable max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">{{ getLabel('addCompany', 'Add Practice') }}</span>
				</v-card-title>
				<v-card-text>
					<v-form ref="practiceVerificationForm" v-model="valid">
						<v-container>
							<v-row>
								<v-col>
									<v-select v-model="selectedIndustry" :items="listOfIndustries" label="Select your industry" outlined :rules="industryRules"> </v-select>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field v-model="practiceName" :rules="practiceNameRules" :label="getLabel('companyName', 'Practice Name')" outlined></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field v-model="practiceVatNumber" :rules="practiceVatNumberRules" label="Vat number" outlined></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field
										v-model="practiceRegNumber"
										:rules="practiceRegNumberRules"
										:label="getLabel('companyNumber', 'Practice Number')"
										outlined
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<VuePhoneNumberInput
										v-model="phone_number"
										:rules="[v => !!v || 'Mobile number is required']"
										default-country-code="ZA"
										:preferred-countries="['ZA']"
										label="Mobile Number"
										outlined
										required
										size="lg"
										class="mt-0"
										:countries-height="40"
										error-color="red"
										:color="phoneNumberColor"
										@update="onChangeTelNumber"
									/>
									<v-col cols="12" class="pa-0 mb-5"><span class="float-left ml-6 text-caption red--text">Required</span></v-col>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field
										v-model="practiceBussinessEmail"
										:rules="requredRule"
										:label="getLabel('companyEmailAddress', 'Practice Email Address')"
										outlined
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field v-model="streetAddress" label="Street address" outlined :rules="streetAddressRules"></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-select v-model="provinceSelected" outlined :items="province_computed" persistent-hint label="Province" :rules="provinceRules"></v-select>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-select
										v-model="province_region"
										outlined
										:items="region_computed"
										:disabled="provinceSelected ? false : true"
										:label="provinceSelected ? 'City/District/Region' : 'Please select province above.'"
										:rules="regionRules"
									></v-select>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field v-model="suburb" label="Suburb" outlined :rules="suburbRules"></v-text-field>
								</v-col>
							</v-row>
						</v-container>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn color="blue darken-1" :loading="loadingInvite" text @click="addPracticeShow = false"> Close </v-btn>
					<v-btn
						:disabled="!validForm"
						large
						:loading="loading"
						class="button-rounded continue-signup-button text-none"
						style="text-transform: none !important"
						color="#FC7E1E"
						@click="SubmitForm()"
						>{{ impersonationMode ? 'Update' : 'Complete sign up' }}<v-icon>mdi-chevron-right</v-icon></v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { bus } from '@/main';
import { mapGetters, mapActions } from 'vuex';
import store from '@/store';
import { provinceRegionPairs, getImpersonationCache } from '@utils';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
export default {
	name: 'CompanySelector',
	components: {
		VuePhoneNumberInput,
	},
	props: {
		hint: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			impersonationMode: getImpersonationCache().impersonationMode,
			loadingInvite: false,
			addPracticeShow: false,
			loading: false,
			requredRule: [v => !!v || 'Required'],
			valid: false,

			practiceNameRules: [v => !!v || 'Required'],

			practiceVatNumberRules: [v => !!v || 'Required'],

			practiceRegNumberRules: [v => !!v || 'Required'],

			practiceContactNumber: null,
			practiceContactNumberRules: [v => !!v || 'Required'],

			phone_number: null,
			phone: null,
			country: null,
			bindProps: {
				mode: 'international',
				placeholder: 'Enter a phone number',
				required: false,
				enabledCountryCode: true,
				enabledFlags: true,
				autocomplete: 'off',
				name: 'telephone',
				maxLen: 25,
				inputOptions: {
					showDialCode: true,
				},
			},

			streetAddressRules: [v => !!v || 'Required'],
			provinceRules: [v => !!v || 'Required'],
			regionRules: [v => !!v || 'Required'],
			profession: null,
			professionRules: [v => !!v || 'Required'],

			suburbRules: [v => !!v || 'Required'],

			industryRules: [v => !!v || 'Required'],

			form: false,

			province_regions: provinceRegionPairs,

			practiceName: null,
			practiceVatNumber: null,
			practiceRegNumber: null,
			practiceBussinessEmail: null,
			streetAddress: null,
			provinceSelected: null,
			province_region: null,
			suburb: null,
			selectedIndustry: null,
		};
	},
	computed: {
		...mapGetters(['company', 'companies', 'user']),

		...mapGetters('company', ['selectedCompany']),

		currentCompany: {
			get() {
				return this.company;
			},
			set(newValue) {
				this.setCompany(newValue);
			},
		},

		companieList() {
			return this.companies;
		},
		industriesConfigsObj() {
			return store.getters.configs.industriesV2;
		},
		listOfIndustries() {
			return Object.keys(this.industriesConfigsObj);
		},
		province_regions_computed() {
			let getpr = store.getters.getProvinceRegions;
			let result = [];
			if (getpr && 'Items' in getpr) {
				getpr.Items.forEach(item => {
					item.subs.forEach(region => {
						result.push({ province: item.name, region: region });
					});
				});
			}
			return result;
		},
		province_computed() {
			let result = [];
			this.province_regions.forEach(set => {
				if (!(set.province in result)) {
					result.push(set.province);
				}
			});
			return result;
		},
		region_computed() {
			let result = [];
			if (this.provinceSelected) {
				this.province_regions.forEach(set => {
					if (this.provinceSelected == set.province) {
						result.push({ text: set.region, value: set, province: set.province, region: set.region });
					}
				});
			}
			return result;
		},
		user() {
			return store.getters.user;
		},
		company() {
			return store.getters.company || {};
		},
		validForm() {
			return this.valid && !!this.practiceContactNumber;
		},
		phoneNumberColor() {
			return this.practiceContactNumber ? 'orange' : 'red';
		},
	},
	methods: {
		...mapActions('company', ['SetCompany', 'CreateCompany']),

		async setCompany(company) {
			await this.SetCompany(company);
			location.reload();
		},
		validate() {
			return this.$refs.practiceVerificationForm.validate();
		},
		async createCompany() {
			var company = {
				name: this.practiceName,
				contact: this.practiceContactNumber,
				email: this.practiceBussinessEmail,
				practice_number: this.practiceRegNumber,
				industry: this.selectedIndustry,
				vat_no: this.practiceVatNumber,
				approved: true,
				address: {
					province: this.province_region.province,
					region: this.province_region.region,
					suburb: this.suburb,
					street: this.streetAddress,
				},
				manager: {
					id: this.user.id,
					name: this.user.name,
					surname: this.user.family_name,
					email: this.user.email,
					contact: this.user.phone_number,
					role: 'PracticeAdmin',
				},
				terms_conditions: true,
			};
			const data = await this.CreateCompany(company);
			await this.setCompany(data);
		},

		onChangeTelNumber(data) {
			this.practiceContactNumber = data.formattedNumber;
		},
		async SubmitForm() {
			let valid = this.validate();
			if (valid) {
				bus.$emit('intent:submit-forms:' + this.name);
				await this.createCompany();
				//redirect to complete page
			}
		},
	},
};
</script>
